import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ContentChild,
  ContentChildren,
  ElementRef,
  EventEmitter,
  HostListener,
  Input, NgZone,
  OnInit,
  Output,
  QueryList, ViewChild,
} from '@angular/core';
import {
  ApiService,
  FieldDefine,
  FieldType,
  FormStatus,
  LanguagesService,
  MessageService,
  SearchDefine,
  SearchType,
  ServiceCode,
  SortType,
  StateService,
  Util
} from '../../../core';
import {UserButtonDirective, UserGridEditFormDirective} from '../../directive';
import {moveItemInArray} from '@angular/cdk/drag-drop';
import {BaseFormComponent} from '../base-form';
import {InlineItemColumn} from '../../define';
import {
  CompositeFilterDescriptor,
  DataResult,
  FilterDescriptor,
  GroupDescriptor,
  process,
  SortDescriptor,
  State
} from '@progress/kendo-data-query';
import {
  ColumnReorderEvent,
  ColumnResizeArgs,
  ColumnVisibilityChangeEvent,
  DataStateChangeEvent,
  GridComponent,
  GridDataResult,
  PageSizeItem
} from '@progress/kendo-angular-grid';
import {
  RowArgs,
  ColumnReorderEvent as ColumnReorderEventTreeList,
  ColumnResizeArgs as ColumnResizeArgsTreeList,
  ColumnVisibilityChangeEvent as ColumnVisibilityChangeEventTreeList
} from '@progress/kendo-angular-treelist';
import {take} from 'rxjs/operators';
import {MultiSelectComponent} from '../multi-select/multi-select.component';


@Component({
  selector: 'gc-grid-form',
  templateUrl: './grid-form.component.html',
  styleUrls: ['./grid-form.component.less']
})

export class GridFormComponent extends BaseFormComponent implements OnInit, AfterViewInit {
  @Input()
  get virtualColumns(): boolean {
    return this.virtualColumnVar;
  }
  set virtualColumns(v) {
    if (v) {
      this.defaultColumnWidth = 150;
    }else{
      this.defaultColumnWidth = 150;
    }
    this.virtualColumnVar = v;
  }

  constructor(protected api: ApiService, protected message: MessageService,
              public lang: LanguagesService, protected state: StateService, protected cd: ChangeDetectorRef,
              protected el: ElementRef,
              protected ngZone: NgZone
  ) {
    super(api, message, lang, el);
    this.searchPaneTitle = lang.define.lib.searchPaneTitle;
  }
  public groups: GroupDescriptor[] = [];
  public gridData: DataResult;
  public dataLoading = false;
  public FormStatusEnum = FormStatus;
  public FieldTypeEnum = FieldType;
  visibleDetailModal = false;
  detailModalTitle = '';
  detailModalIcon = 'add';
  visibleColumnPanel = false;
  private visibleFields = [];

  visibleSearchPane = false;
  searchBySearchPane = false;


  @Input()
  searchPaneTitle = null;

  // Selected row
  currentIndex = null;

  // dateFormat = Config.dateFormat;

  // Search info
  searchCache: { [key: string]: SearchDefine } = {};
  searchCacheSearchPane: { [key: string]: SearchDefine } = {};
  // Options for list field in search box
  searchOptions: { [key: string]: any[] } = {};
  public pageSizes: PageSizeItem[] = [
    {text: '5', value: 5},
    {text: '10', value: 10},
    {text: '20', value: 20},
    {text: '50', value: 50},
    {text: '100', value: 100},
    {text: '500', value: 500},
    {text: '1000', value: 1000},
    {text: '2000', value: 2000}];

  settingCommands = [];
  editModeFieldCheck = {};
  columnTableFields: GridDataResult;
  public columnTableState: State = {
    take: 20,
    skip: 0
  };

  public defaultColumnWidth = 150;
  private virtualColumnVar = false;
  @ViewChild('grid') grid: GridComponent;

  @ContentChildren(UserButtonDirective) userButtonDirectives: QueryList<UserButtonDirective>;
  @ContentChild(UserGridEditFormDirective) editFormDirective: UserGridEditFormDirective;
  @Input() selectionFields: Array<string> = [];
  @Input() inlineItems: InlineItemColumn[] = [];
  @Input() selection = false;
  @Input() view = false;
  @Input() groupAble = false;
  @Input() autoSize = false;

  @Input() copyDialogTitle = '';
  @Input() addDialogTitle = '';
  @Input() updateDialogTitle = '';
  @Input() viewDialogTitle = '';

  @Output()
  changed: EventEmitter<{ name: string, index: number, value: any, listItem: any }> = new EventEmitter();
  @Output()
  imported: EventEmitter<any> = new EventEmitter<any>();

  selectedKeys = [];
  public sortDescriptor: SortDescriptor[] = [
    // {field: 'email', dir: 'asc'}
  ];
  public filterDescriptor: CompositeFilterDescriptor = {
    logic: 'and',
    filters: [
      // {logic: 'and', filters: [{ field: 'email', operator: 'contains', value: 'minh@'}]},
      // {logic: 'and', filters: [{field: 'user_name', operator: 'contains', value: 'a'}]},
    ]
  };

  multiSelectComponent: MultiSelectComponent = null;

  public columnSettingPhpCode = null;

  private static removeArrayItem(items: any[], item: any): void {
    const index = items.indexOf(item);
    if (index > -1) {
      items.splice(index, 1);
    }
  }

  private static addArrayItem(items: any[], item: any): void {
    if (!items.includes(item)) {
      items.push(item);
    }
  }

  ngOnInit(): void {
    if (this.height) {
      this.formHeight = this.height;
    }else{
      if (!this.bottomDistance) {
        this.formHeight = null;
      }
    }
  }

  openMultiSelectDetail(event: MultiSelectComponent): void {
    this.multiSelectComponent = event;
  }

  protected fitColumns(): void {
    if (!this.isVisible()) {
      return;
    }

    // this.dataLoading = true;
    this.ngZone.onStable.asObservable().pipe(take(1)).subscribe(() => {
      if (this.grid) {
        this.grid.autoFitColumns();
      }
      // this.dataLoading = false;
    });
  }
  protected fitSystemColumns(): void {
    if (!this.isVisible()) {
      return;
    }
    this.ngZone.onStable.asObservable().pipe(take(1)).subscribe(() => {
      let count = 0;
      this.grid.columns.forEach(column => {
        count++;
        if (column.title && column.title !== '　') {
          return;
        }
        this.grid.autoFitColumn(column);

        if (count >= 3) {
          return;
        }
      });
    });
  }

  onFieldValueChange(value: any, serial, name): void {
    const index = this.data.findIndex(d => d.serial === serial);
    this.changed.emit({name, index, value: value.value, listItem: value.listItem});
  }

  init(): void {
    this.loadDefine();
  }

  fieldEditable(serial: number, field: FieldDefine): boolean {
    // if (field.editMode) {
    //   return true;
    // }

    if (!this.editCache[serial].edit) {
      return false;
    }
    return (field.update && (this.status === FormStatus.Edit)) ||
      (field.insert && (this.status === FormStatus.Copy || this.status === FormStatus.Insert));
  }

  public loadDefine(): void {
    if (!this.apiUrl) {
      return;
    }
    this.dataLoading = true;
    this.api.define(this.apiUrl, ((code, message, define) => {
      this.dataLoading = false;
      if (code === 200) {
        define.sortInfo = {};
        define.searchInfo = {};

        // Should reset data
        this.data = [];
        const optionsMap = this.define ? this.define.optionsMap : null;
        if (optionsMap) {
          define.optionsMap = optionsMap;
        }else{
          define.optionsMap = {};
        }
        this.define = define;
        this.visibleFields = [];
        define.fields.forEach(field => {
          if (!field.hidden) {
            this.visibleFields.push(field);
          }
        });

        // Init columns
        this.columnTableFields = process(this.visibleFields, this.columnTableState);

        this.defineLoaded();
        this.loaded.emit();

        // Date time adjust
        this.define.fields.forEach(
          (field) => {
            if ((field.type === FieldType.Date || field.type === FieldType.DateTime) && field.defaultValue) {
              field.defaultValue = Util.toDatetime(field.defaultValue);
            }
          }
        );

        // Reset filter
        this.filterDescriptor.filters = [];
        this.loadSearchCache();


        // Apply backward info
        this.state.applyState(define);

        // Change search info from backward
        this.updateState();

        // Field group
        this.loadFieldGroups();

        // Load data
        this.load();

      }
    }));
  }

  loadSearchOptions(): void {
    this.define.fields.forEach(field => {
      if (field.listName) {
        if (!this.define.optionsMap) {
          this.define.optionsMap = {};
        }
        if (!this.define.optionsMap[field.listName]) {
          // Default param
          const param = this.getListOptionsDefaultParams(field);
          this.api.getListValues(field.listName, param, null, null, result => {
            if (field.tree) {
              this.define.optionsMap[field.listName] = result;
              this.searchOptions[field.name] = Util.expandTreeListValues(this.define.optionsMap[field.listName]);
            }else{
              this.define.optionsMap[field.listName] = Util.toKendoListValues(result);
            }
          });
        }
      }
    });
  }

  private getListOptionsDefaultParams(define: FieldDefine): any {
    if (define.listParam) {
      if (Array.isArray(define.listParam)){
        const param = [];
        define.listParam.forEach(item => {
          const defaultValue = this.define.fieldByNames[item].defaultValue;
          if (defaultValue) {
            param.push(defaultValue);
          }else {
            param.push(-1);
          }
        });
        return param;
      }else{
        const defaultValue = this.define.fieldByNames[define.listParam].defaultValue;
        if (defaultValue) {
          return defaultValue;
        }else {
          return -1;
        }
      }
    }
    return null;
  }

  loadSearchCache(): void {
    this.define.fields.forEach(field => {
      this.searchCache[field.name] = this.createSearchCacheField(field);
      this.searchCacheSearchPane[field.name] = this.createSearchCacheField(field);
    });
  }

  footerAvailable(): boolean {
    if (!this.define.summaries) {
      return false;
    }
    if (!this.data || this.data.length === 0) {
      return false;
    }
    for (const fieldName of Object.keys(this.define.summaries)) {
      const field = this.define.fieldByNames[fieldName];
      if (field.show && !field.hidden) {
        return true;
      }
    }
    return false;
  }

  createSearchCacheField(field: FieldDefine): SearchDefine {
    let defaultType;
    if (field.listValues || field.listName) {
      if (field.autocomplete) {
        defaultType = SearchType.Contains;
      }else{
        defaultType = SearchType.In;
      }
    } else {
      switch (field.type) {
        case FieldType.Date:
        case FieldType.DateTime:
        case FieldType.Int:
        case FieldType.Float:
          defaultType = SearchType.In;
          break;
        case FieldType.Boolean:
          defaultType = SearchType.Equal;
          break;
        default:
          defaultType = SearchType.Contains;
      }
    }


    return {name: field.name, type: defaultType, value1: null, value2: null, values: [], searchNull: false};
  }

  public checkAll(check = false): void {
    if (!check) {
      this.selectedKeys = [];
    }
  }

  public load(OnLoaded: () => void = null): void {
    this.dataLoading = true;
    // const t1 = Date.now();
    super.load(() => {
      // const t2 = Date.now();
      this.editModeFieldCheck = {};
      this.dataLoading = false;
      this.updateEditCache();
      this.status = FormStatus.View;
      this.checkAll(false);
      this.loadSearchOptions();
      this.dataLoaded();
      this.loaded.emit();
      // const t3 = Date.now();
      this.loadGridData();
      setTimeout(() => {
        this.resize();
        if (this.autoSize) {
          this.fitColumns();
        } else {
          this.fitSystemColumns();
        }
        if (OnLoaded) {
          OnLoaded();
        }
      }, 100);
    });
  }

  startEdit(serial: number, event): void {
    this.cancel();
    this.clearEditCache();
    this.checkAll(false);
    this.clearFileInput(serial);
    this.editCache[serial].edit = true;
    this.status = FormStatus.Edit;
    GridFormComponent.addArrayItem(this.selectedKeys, serial);
    if ((event.ctrlKey && this.priorInlineUpdate) || (!event.ctrlKey && !this.priorInlineUpdate)) {
      this.detailModalTitle = this.updateDialogTitle;
      this.detailModalIcon = 'change-manually';
      this.openDetailModal(serial);
    }else{
      if (this.autoSize) {
        this.fitColumns();
      }
    }

  }

  startEditMulti(): void {
    if (!this.checkSelected()) {
      this.warning(this.lang.define.lib.selectRowMessage);
      return;
    }

    this.clearEditCache();
    this.selectedKeys.forEach(key => {
      const serial = +key;
      this.editCache[serial].edit = true;
      this.clearFileInput(serial);
    });
    this.status = FormStatus.Edit;
    if (this.autoSize) {
      this.fitColumns();
    }
  }

  startCopy(serial: number): void {
    this.cancel();
    this.clearEditCache();
    this.checkAll(false);
    this.clearFileInput(serial);

    const newSerial = this.serial() + 1;
    this.createCopyItem(serial, newSerial);
    this.loadGridData();
    this.status = FormStatus.Copy;
    this.detailModalTitle = this.copyDialogTitle;
    this.detailModalIcon = 'copy';
    this.openDetailModal(newSerial);
  }

  startCopyMulti(): void {
    if (!this.checkSelected()) {
      this.warning(this.lang.define.lib.selectRowMessage);
      return;
    }
    this.clearEditCache();
    let serial = this.serial() + 1;
    let copyCount = 0;
    const newSelectedKeys = [];
    this.selectedKeys.forEach(key => {
      this.createCopyItem(key, serial);
      newSelectedKeys.push(serial);
      serial++;
      copyCount++;
    });
    this.loadGridData();

    this.selectedKeys = newSelectedKeys;

    this.status = FormStatus.Copy;
    if (copyCount === 1) {
      this.detailModalTitle = this.updateDialogTitle;
      this.detailModalIcon = 'change-manually';
      this.openDetailModal(serial - 1);
    }else{
      this.ngZone.onStable.asObservable().pipe(take(1)).subscribe(() => {
        this.grid.focusCell(this.data.length - 1, 2);
      });
    }
  }

  startInsert(event = null): void {
    this.checkAll(false);
    this.clearEditCache();
    const serial = this.serial() + 1;
    const item = {new: true, serial};
    this.initDefaultValue(item);
    GridFormComponent.addArrayItem(this.selectedKeys, serial);
    this.editCache[serial] = {
      edit: true,
      delete: false,
      data: {...item}
    };

    this.data.push(item);
    this.loadGridData();

    this.status = FormStatus.Insert;

    if ((event && event.ctrlKey) || true) {
      this.detailModalTitle = this.addDialogTitle;
      this.detailModalIcon = 'add';
      this.openDetailModal(serial);
    }
  }

  cancelEdit(serial: number): void {
    if (serial || true) {
      this.cancel();
    }

    //
    // this.clearValidate();
    // const index = this.data.findIndex(item => item.serial === serial);
    // Object.assign(this.data[index], this.editCache[serial].data);
    // Util.objectAssign(this.data[index], this.editCache[serial].data);
    // this.editCache[serial].edit = false;
    // KendoGridFormComponent.removeArrayItem(this.selectedKeys, serial);
    // if (!this.selection) {
    //   this.checkAll(false);
    // }
    // if (!this.checkSelected()) {
    //   this.status = FormStatus.View;
    // }
  }

  cancel(): void {
    this.clearValidate();
    // Cancel editing
    this.selectedKeys.forEach(key => {
      const serial = +key;
      const index = this.data.findIndex(item => item.serial === serial);
      if (index > -1) {
        Util.objectAssign(this.data[index], this.editCache[serial].data);
        this.editCache[serial].edit = false;
      }
    });

    // Remove editCache and map check
    let i = this.data.length - 1;
    while (i >= 0 && this.data[i].new === true) {
      delete this.editCache[this.data[i].serial];
      GridFormComponent.removeArrayItem(this.selectedKeys, this.data[i].serial);
      i--;
    }

    if (!this.selection) {
      this.checkAll(false);
    }

    // Cancel insert and copy
    this.data = this.data.filter(d => (d.new === undefined || !d.new));
    this.loadGridData();
    this.status = FormStatus.View;

    if (!this.selection) {
      this.selectedKeys = [];
    }
  }

  viewDetail(serial: number): void {
    this.detailModalTitle = this.viewDialogTitle;
    this.detailModalIcon = 'align-justify';
    this.openDetailModal(serial);
  }

  save(serial: number = null, OnSaved: (success: number, message: string) => void = null): void {
    if (serial == null) {
      if (!this.checkSelected()) {
        this.warning(this.lang.define.lib.selectRowMessage);
        return;
      }
    }

    super.save(serial, (success, message) => {
      if (success === ServiceCode.Success) {
        if (this.changeToViewAfterUpdate) {
          if (serial == null) {
            this.checkAll(false);
            this.data.forEach(item => {
              if (item.new) {
                delete item.new;
              }
            });
          } else {
            GridFormComponent.removeArrayItem(this.selectedKeys, serial);
          }
          if (this.currentIndex !== null) {
            this.currentIndex = null;
            this.visibleDetailModal = false;
          }
        }
      }
      if (OnSaved) {
        OnSaved(success, message);
      }
    });
  }

  excel(): void {
    this.dataLoading = true;
    this.api.excel(this.apiUrl, this.define, {}, (code, msg) => {
      this.dataLoading = false;
      if (code !== ServiceCode.Success) {
        alert(msg);
      }
    });
  }

  deleteConfirm(serial: number = null): void {
    this.message.confirm(this.lang.define.lib.deleteConfirmMessage, (r) => {
      if (r) {
        this.delete(serial);
      }
    });
  }

  delete(serial: number = null): void {
    if (serial == null && !this.checkSelected()) {
      this.warning(this.lang.define.lib.selectRowMessage);
      return;
    }
    if (serial == null) {
      this.clearEditCache(true);
      this.selectedKeys.forEach(key => {
        const s = +key;
        if (this.selectedKeys.includes(s)) {
          this.editCache[s].delete = true;
        }
      });
    }

    super.delete(serial, (success, _) => {
      if (success === ServiceCode.Success) {
        this.load();
      }
    });
  }

  checkSelected(): boolean {
    return this.selectedKeys.length > 0;
  }

  saveSetting(): void {
    this.dataLoading = true;
    this.api.setting(this.apiUrl, this.define, false, (code, message) => {
      this.dataLoading = false;
      if (code !== 200) {
        this.error(message);
      }
    });
  }

  resetSetting(): void {
    this.dataLoading = true;
    this.api.setting(this.apiUrl, this.define, true, (code, message) => {
      this.dataLoading = false;
      if (code !== 200) {
        this.error(message);
      } else {
        this.init();
      }
    });
  }

  public edit(): void {
    this.startEditMulti();
  }

  public getCheckedData(): any[] {
    const ret = [];
    this.selectedKeys.forEach(key => {
      const serial = +key;
      const idx = this.data.findIndex(d => d.serial === serial);
      ret.push(this.data[idx]);
    });
    return ret;
  }

  openDetailModal(serial: number): void {
    // Show if count of showed field > 10
    // let count = 0;
    // this.define.fields.forEach(field => {
    //   if (field.editable) {
    //     count++;
    //   }
    // });

    this.currentIndex = this.data.findIndex(d => d.serial === serial);
    this.visibleDetailModal = true;
  }

  ngAfterViewInit(): void {
    this.loadUserFields();
    this.cd.detectChanges();
  }

  public gridSelectionKey(context: RowArgs): number {
    return context.dataItem.serial;
  }

  public columnVisibilityChange(event: ColumnVisibilityChangeEvent | ColumnVisibilityChangeEventTreeList): void {
    event.columns.forEach(column => {
      // @ts-ignore
      const fieldName = column.field;
      this.define.fieldByNames[fieldName].show = !column.hidden;
    });
  }

  public columnResize(event: Array<ColumnResizeArgs|ColumnResizeArgsTreeList>): void {
    event.forEach(arg => {
      // @ts-ignore
      const fieldName = arg.column.field;
      if (fieldName && this.define.fieldByNames[fieldName]) {
        this.define.fieldByNames[fieldName].width = arg.column.width;
      }
    });
  }

  public columnReorder(event: ColumnReorderEvent | ColumnReorderEventTreeList): void {
    // @ts-ignore
    const fieldName = event.column.field;
    let range = event.newIndex - event.oldIndex;
    let step = 1;
    if (range < 0) {
      step = -1;
      range = -range;
    }
    const oldIndex = this.define.fields.findIndex(rec => rec.name === fieldName);
    if (-1 === oldIndex) {
      return;
    }
    let newIndex = oldIndex;
    while (range > 0) {
      newIndex += step;
      if (!this.define.fields[newIndex].hidden && this.define.fields[newIndex].show) {
        range--;
      }
    }

    moveItemInArray(this.define.fields, oldIndex, newIndex);
    this.loadFieldGroups();
  }

  public sortChange(sort: SortDescriptor[]): void {
    if (sort.length < 1) {
      return;
    }
    this.sortDescriptor = sort;
    this.define.sortInfo = {};
    if (sort[0].dir === 'asc') {
      this.define.sortInfo[sort[0].field] = SortType.Asc;
    } else if (sort[0].dir === 'desc') {
      this.define.sortInfo[sort[0].field] = SortType.Desc;
    }

    this.load();
  }

  // TODO: 1. Update option list for search box, 2. Get search info from backward
  public filterChange(event: CompositeFilterDescriptor): void {
    const filterFields = [];
    event.filters.forEach(item => {
      const c: CompositeFilterDescriptor = item as CompositeFilterDescriptor;
      if (c.filters && c.filters[0]) {
        filterFields.push((c.filters[0] as FilterDescriptor).field);
      }
    });
    const oldFilterFields = [];
    this.filterDescriptor.filters.forEach(item => {
      const c: CompositeFilterDescriptor = item as CompositeFilterDescriptor;
      if (c.filters && c.filters[0]) {
        oldFilterFields.push((c.filters[0] as FilterDescriptor).field);
      }
    });
    this.filterDescriptor = event;

    // Delete cleared filter
    oldFilterFields.forEach(field => {
      if (!filterFields.includes(field)) {
        this.searchCache[field] = this.createSearchCacheField(this.define.fieldByNames[field]);
      }
    });

    // Search
    const searchInfo: { [key: string]: any } = {};
    filterFields.forEach(field => {
      searchInfo[field] = this.searchCache[field];
    });
    this.searchBySearchPane = false;
    // console.log(this.searchCache);
    this.define.searchInfo = searchInfo;
    this.define.pageIndex = 1;
    this.load();
  }

  public onPageChange(event: any): void {
    this.define.pageSize = event.take;
    this.define.pageIndex = (event.skip / this.define.pageSize) + 1;
    this.load();
  }

  public groupChange(groups: GroupDescriptor[]): void {
    groups.forEach(rec => {
      const field = this.define.fieldByNames[rec.field];
      if ((field.listName && !field.autocomplete) || field.listValues) {
        rec.field = Util.complexFieldName(rec.field) + '.text';
      }
    });
    this.groups = groups;
    this.loadGridData();
  }

  @HostListener('window:resize', ['$event'])
  onResize(_): void {
    this.resize();
    setTimeout(() => {
      if (this.autoSize) {
        this.fitColumns();
      }else{
        this.fitSystemColumns();
      }
    }, 100);


  }

  onImported(): void {
    this.imported.emit();
  }

  private updateState(): void {
    Object.keys(this.define.searchInfo).forEach(key => {
      this.searchCache[key] = this.define.searchInfo[key];
      this.filterDescriptor.filters.push({
        logic: 'and',
        filters: [
          {field: key, operator: 'contains', value: '@'}
        ]
      });
    });

    // Update kendo state
    Object.keys(this.define.sortInfo).forEach(key => {
      if (this.define.sortInfo[key] === SortType.Desc) {
        this.sortDescriptor.push({field: key, dir: 'desc'});
      } else {
        this.sortDescriptor.push({field: key, dir: 'asc'});
      }
    });
  }

  private loadGridData(): void {
    this.gridData = process(this.data, {group: this.groups});
  }

  private createCopyItem(selectedSerial: number, serial: number): void {
    const index = this.data.findIndex(d => d.serial === selectedSerial);
    const item = {...this.data[index]};
    this.initDefaultValue(item);
    // Remove can not edit item
    this.define.fields.forEach(field => {
      if (!field.editable && !field.defaultValue) {
        delete item[field.name];
      }
    });

    item.new = true;
    item.serial = serial;

    this.editCache[serial] = {
      edit: true,
      delete: false,
      data: {...item}
    };
    this.data.push(item);
  }

  settingCommandClick(e): void {
    if (e.onclick) {
      e.onclick();
    }
  }

  public loadSettingCommands(): void{
    /*
    if (this.define.optionInsert && this.status === FormStatus.View) {
      ret.push({
        icon: 'plus',
        text: this.lang.define.lib.add,
        onclick: () => {
          this.startInsert();
        }
      });
    }

    if (this.define.optionUpdate && this.checkSelected() && this.status === FormStatus.View) {
      ret.push({
        icon: 'edit',
        text: this.lang.define.lib.edit,
        onclick: () => {
          this.startEditMulti();
        }
      });
    }
    if (this.define.optionInsert && this.checkSelected() && this.status === FormStatus.View) {
      ret.push({
        icon: 'copy',
        text: this.lang.define.lib.copy,
        onclick: () => {
          this.startCopyMulti();
        }
      });
    }
    if (this.define.optionDelete && this.checkSelected() && this.status === FormStatus.View) {
      ret.push({
        icon: 'trash',
        text: this.lang.define.lib.delete,
        onclick: () => {
          this.deleteConfirm();
        }
      });
    }

    if (this.define.optionExcel && this.status === FormStatus.View) {
      ret.push({
        icon: 'excel',
        text: this.lang.define.lib.excel,
        onclick: () => {
          this.excel();
        }
      });
    }

    if ((this.define.optionInsert || this.define.optionUpdate) && this.status === FormStatus.Edit) {
      ret.push({
        icon: 'close',
        text: this.lang.define.lib.cancel,
        onclick: () => {
          this.cancel();
        }
      });
    }
    if ((this.define.optionInsert || this.define.optionUpdate) && this.status === FormStatus.Edit) {
      ret.push({
        icon: 'save',
        text: this.lang.define.lib.save,
        onclick: () => {
          this.save();
        }
      });
    }

    */

    this.settingCommands = [
      {
        icon: 'table',
        text: this.lang.define.lib.fitColumn,
        onclick: () => {
          this.fitColumns();
        },
        setting: true
      },
      {
        icon: 'save',
        text: this.lang.define.lib.saveSetting,
        onclick: () => {
          this.saveSetting();
        },
        setting: true
      },
      {
        icon: 'reset',
        text: this.lang.define.lib.resetSetting,
        onclick: () => {
          this.resetSetting();
        },
        setting: true
      }
    ];
  }

  public columnTableStateChange(state: DataStateChangeEvent): void {
    this.columnTableState = state;
    this.columnTableFields = process(this.visibleFields, this.columnTableState);
  }

  public editModeFieldCheckClick(fieldName: string): void {
    const setValue = !this.editModeFieldCheck[fieldName];
    const field = this.define.fieldByNames[fieldName];
    this.data.forEach(rec => {
      if (field.editMode || this.fieldEditable(rec.serial, field)) {
        rec[fieldName] = setValue;
      }
    });
  }
  private createColumnSettingPhpCode(): string {
    let ret = '';
    this.define.fields.forEach(field => {
      if (field.width) {
        ret = ret + '$this->setWidth("' + field.name + '",' + field.width + ');\n';
      }
      if (field.locked) {
        ret = ret + '$this->setLocked("' + field.name + '");\n';
      }
    });
    return ret;
  }
  public openColumnSetting(event): void{
    if (event.ctrlKey) {
      this.columnSettingPhpCode = this.createColumnSettingPhpCode();
    }else{
      this.columnSettingPhpCode = null;
    }
    this.visibleColumnPanel = true;
  }
  // TODO: 1.Fix bug of list param in filter panel
}


